// extracted by mini-css-extract-plugin
var _1 = "ModalContainer-module__carouselSlider--fAcl7";
var _2 = "ModalContainer-module__container--wtFWC";
var _3 = "ModalContainer-module__content--SeW6C";
var _4 = "ModalContainer-module__inner--eQyIN";
var _5 = "ModalContainer-module__interactiveSidebar--yH_P1";
var _6 = "ModalContainer-module__isNextToSidebar--PtqFO";
var _7 = "ModalContainer-module__shouldAlignToTop--WmxTs";
var _8 = "ModalContainer-module__underlay--id2BB";
export { _1 as "carouselSlider", _2 as "container", _3 as "content", _4 as "inner", _5 as "interactiveSidebar", _6 as "isNextToSidebar", _7 as "shouldAlignToTop", _8 as "underlay" }
